import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import DisconnectedNavBar from '../../components/DisconnectedNavBar';
import MainFeaturedPost from './MainFeaturedPost';
import "./style.css"
import WhoAreWe from './WhoAreWe';
import Contactus from './Contactus';
import MapComp from './MapComp';



const mainFeaturedPost = {
  title: 'פישוט ההפניה לתיק',
  description:`בכל פעם שאתה מפנה תיק אתה מוגבל על ידי מי שאתה יודע,
   השעה שיש לך והיכן אתה נמצא. עכשיו, עם 
   LegalMates, אתה לא צריך להיות. באמצעות LegalMates אתה יכול להפנות תיקים לעורכי דין למרחקים ולבחור את עורך הדין שלדעתך הוא המתאים ביותר לטיפול בתיק שלך. ואם אתם מחפשים תיק חדש, פשוט חפשו, הציעו וקבלו הפניה חדשה. החשוב מכל, אתה יכול לעשות זאת בחינם מהנוחות של המקלדת
  (שולחן העבודה או הנייד) שלך.
`,
  image: 'https://source.unsplash.com/Ws4wd-vJ9M0/1600x900/',
  imgText: 'lawyer image'
};

const sections = [
  { title: 'הרשמה / התחברות', url: 'SignIn' },
  { title: 'צור קשר', url: '#' },
  { title: 'מי אנחנו', url: '#' },
  { title: 'אח בוגר', url: '#' },
  { title: 'פורום מקצועי', url: '#' },
  { title: 'הפניות תיקים', url: '#' },
];

export default function MainPage() {
  return (
    <React.Fragment>
      <CssBaseline />
      <Container maxWidth="lg">
        <DisconnectedNavBar sections={sections} />
        <MainFeaturedPost post={mainFeaturedPost} />
        <WhoAreWe />
        <Contactus />
        <MapComp />
      </Container>
    </React.Fragment>
  );
}
